var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHybnost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.5672 5.57141H20.0248C12.4821 5.57141 6.36743 11.686 6.36743 19.2288V58.7711C6.36743 66.3139 12.4821 72.4286 20.0248 72.4286H59.5672C67.11 72.4286 73.2246 66.3139 73.2246 58.7711V19.2288C73.2246 11.686 67.11 5.57141 59.5672 5.57141Z",
    stroke: "#15D1EA",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6433 34.3732C42.4853 35.6458 47.6649 41.6463 47.6649 48.8558C47.6649 56.991 41.0702 63.5875 32.9333 63.5875C24.7964 63.5875 18.2017 56.9927 18.2017 48.8558C18.2017 41.5124 23.5736 35.4243 30.6028 34.308",
    stroke: "#15D1EA",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5522 39.491C39.6482 40.6348 42.6536 44.3941 42.6536 48.8558C42.6536 54.2243 38.3017 58.5779 32.9315 58.5779C27.5613 58.5779 23.2095 54.2261 23.2095 48.8558C23.2095 44.346 26.2801 40.5541 30.443 39.455",
    stroke: "#15D1EA",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5523 30.7909V42.9035C35.5523 44.3135 34.4085 45.4572 32.9986 45.4572C31.5886 45.4572 30.4448 44.3135 30.4448 42.9035V30.8115C30.4448 27.1758 33.3352 24.1979 36.9691 24.088C40.7611 23.9746 43.897 27.0178 43.897 30.8115V38.8453C43.897 38.9398 43.9743 39.0171 44.0687 39.0171H48.4807C51.2491 39.0171 53.7461 40.6778 54.816 43.2315L59.1181 53.498C61.1016 53.498 62.7091 55.1054 62.7091 57.089V58.1005H55.3261L50.4213 46.3674",
    stroke: "#15D1EA",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1032 24.0862C39.6945 24.0862 41.7951 21.9856 41.7951 19.3944C41.7951 16.8031 39.6945 14.7025 37.1032 14.7025C34.512 14.7025 32.4114 16.8031 32.4114 19.3944C32.4114 21.9856 34.512 24.0862 37.1032 24.0862Z",
    stroke: "#15D1EA",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3279 58.1005C54.9483 57.9991 44.335 58.1005 44.335 58.1005",
    stroke: "#15D1EA",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHybnost);
export default __webpack_public_path__ + "static/media/hybnost.c1c49ef6133ae85009493ae49a6687ae.svg";
export { ForwardRef as ReactComponent };